import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';

export class MakePifPaymentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { renderModal, showModal } = this.state;
        console.log("pif component state:", this.state);
        console.log("pif component props:", this.props);
        return (
            <>
                <div onClick={() => this.setState({
                    showModal: true,
                    renderModal: true
                })} className="" href="javascript:void(220221)">
                    <a href="javascript:void(220221)" class="btn btn-block btn-sm btn-primary btn-pay text-white">PAY BALANCE</a>
                </div>
                {renderModal &&
                    <MakePifPaymentModalComponent
                        accountNumber={this.props.accountNumber}
                        amount={this.props.pifBalance}
                        pifPrice={ this.props.pifPrice}
                        pifBalance={this.props.pifBalance}
                        hasPaid={this.props.hasPaid}
                        pifSavings={this.props.pifSavings}
                        descriptionTitle={this.props.descriptionTitle}
                        description={this.props.description}
                        showModal={showModal}
                        handleClose={() => {
                            this.setState({ showModal: false });
                        }}
                        onExited={() => {
                            this.setState({ renderModal: false });
                        }} />}
            </>
        );
    }
}


class MakePifPaymentModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Amount: props.pifBalance,
            Name: '', // Name will be shown but not editable
            AccountNumber: props.accountNumber,
            PifPrice: props.pifPrice,
            PifBalance: props.pifBalance,
            hasPaid: props.hasPaid,
            pifSavings: props.pifSavings
        };
        this.removePifPaymentContainer = this.removePifPaymentContainer.bind(this);
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    removePifPaymentContainer() {
        document.querySelector("#pifPayContainer").remove();
    }   
    

    save = (e) => {
        this.setState({
            isSaving: true,
            errors: null
        },
            () => {
                const payload = {
                    Amount: this.state.Amount
                };

                fetch(`/api/talent/${this.state.AccountNumber}/makepayment`,
                    {
                        method: "POST",
                        body: JSON.stringify(payload),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(req => req.json())
                    .then(resp => {
                        if (resp.redirectUrl) {
                            window.location.href = resp.redirectUrl;
                        } else {
                            this.setState({
                                errors: ["Payment could not be processed. Please try again later or contact Customer Care."],
                                isSaving: false
                            });
                        }
                    })
                    .catch(error => {
                        this.setState({
                            errors: ["An error occurred when trying to submit a payment. Please try again later or contact Customer Care."],
                            isSaving: false
                        });
                    });
            });
    }

    render() {
        const { showModal, handleClose, onExited } = this.props;

        return (
            <Modal isOpen={showModal} onClosed={onExited}>
                <ModalHeader toggle={handleClose}>
                    Payout Remaining Balance ${this.state.PifBalance}
                </ModalHeader>
                <ModalBody>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label>Amount</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">$</div>
                                </div>
                                <input 
                                    type="number" 
                                    name="Amount" 
                                    value={this.state.Amount} 
                                    onChange={this.handleInputChange}
                                    placeholder="Enter payment amount" 
                                    className="form-control" 
                                    step="0.01"
                                    min="0"
                                    disabled={this.state.isSaving}
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.isSaving && <div className="float-left">
                        Processing...
                    </div>}
                    {this.state.errors && <div className="float-left text-left">
                        {this.state.errors.map(e => <div key={e}>{e}</div>)}
                    </div>}
                    {!this.state.errors && !this.state.isSaving &&
                    <a href="https://stripe.com" className="mr-auto" target="_blank" rel="noopener noreferrer">
                        <img src="/Powered_by_Stripe.svg" style={{ height: '30px' }} alt="Stripe Seal" />
                    </a>}
                    <Button onClick={this.save} disabled={this.state.isSaving}>
                        Pay Balance
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
